import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-32 bg-[#12263A] text-white" data-testid="site-footer">
      <div className="px-6 md:px-12 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <img src="/brand/dark-background-logo.png" alt="The Extension Works — making home extensions simple" className="h-20 w-auto mb-6" data-testid="footer-logo" />
          <p className="text-base font-semibold text-white/90 mb-3">Making home extensions simple.</p>
          <p className="text-sm text-white/60 max-w-md leading-relaxed">
            Single-storey rear extensions, designed and built in-house at a fixed price.
            All prices shown include VAT at 20%.
          </p>
        </div>
        <div>
          <div className="label-eyebrow mb-4 text-[#C79A3B]">Build</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/how-it-works" className="hover:text-[#C79A3B]">How It Works</Link></li>
            <li><Link to="/extension-rules" className="hover:text-[#C79A3B]">Extension Rules</Link></li>
            <li><Link to="/quote" className="hover:text-[#C79A3B]">Instant Quote</Link></li>
            <li><Link to="/about" className="hover:text-[#C79A3B]">About</Link></li>
            <li><Link to="/faq" className="hover:text-[#C79A3B]">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-[#C79A3B]">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4 text-[#C79A3B]">Legal</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/legal/terms" className="hover:text-[#C79A3B]">Terms & Conditions</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-[#C79A3B]">Privacy Policy</Link></li>
            <li><Link to="/legal/cookies" className="hover:text-[#C79A3B]">Cookie Policy</Link></li>
            <li><Link to="/legal/warranty" className="hover:text-[#C79A3B]">Warranty</Link></li>
            <li><Link to="/legal/deposit" className="hover:text-[#C79A3B]">Deposit & Cancellation</Link></li>
            <li><Link to="/complaints" className="hover:text-[#C79A3B]">Complaints</Link></li>
            <li><Link to="/admin" className="hover:text-[#C79A3B]">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 px-6 md:px-12 lg:px-16 py-6 flex flex-col gap-2 text-xs text-white/50">
        <div data-testid="footer-legal">Esskay Homes Ltd, trading as The Extension Works.</div>
        <div className="flex flex-col md:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} The Extension Works · All prices include VAT</span>
          <span>12-month workmanship warranty · Building control booked on your behalf</span>
        </div>
      </div>
    </footer>
  );
}
